// Default user data
export const defaultUserData = {
    id: undefined,
    fullname: undefined,
    email: undefined,
    phone_number: undefined,
    language: undefined,
    country_code:undefined,
    note: undefined,
    position: undefined,
    eshop_access: undefined,
    active: undefined,
    subscribers: undefined,
}